<app-table
  *ngIf="cols && dropdownFilters"
  [cols]="cols"
  [findPage]="findPage"
  [service]="financialService"
  modelName="erros"
  sortField="paymentResponseMessageId"
  addLabel="Novo erro"
  [actionButtons]="actionButtons"
  (actionButtonClick)="buttonClick($event)"
  [addButton]="permission"
  [dropdownFilters]="dropdownFilters"
  [changeColumns]="true"
  tableTitle="Códigos de erro de cobrança"
  [multiSelectFilter]="true"
>
</app-table>
<p-confirmPopup class="danger" />
